import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import PageContainer from '../SolvPatternLibrary/PageContainer';
import InsuranceForm from './InsuranceForm';
import InsuranceFileUpload from './InsuranceFileUpload';
import Title from './components/Title';
import VerticallyAlignedContainer from '../SolvPatternLibrary/VerticallyAlignedContainer';
import styled from 'styled-components';

const StyledPageContainer = styled(PageContainer)`
  width: 100%;
`;

class DesktopAddInsurance extends Component {
  static propTypes = {
    handleSkip: PropTypes.func,
  };

  render = () => (
    <VerticallyAlignedContainer>
      <StyledPageContainer container justify="center" spacing={24}>
        <Grid item xs={12}>
          <Title>Add Insurance</Title>
        </Grid>
        <InsuranceFileUpload {...this.props} />
        <InsuranceForm {...this.props} />
      </StyledPageContainer>
    </VerticallyAlignedContainer>
  );
}

export default DesktopAddInsurance;
